import React from "react";
import { usePriceRangesDataContext } from "@/store/PriceRangesProvider";
import { useUserDataContext } from "@/store/UserProvider";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import FirstLoader from "@/ui/ContainerLoader/FirstLoader";
import { useFirstLoader } from "@/store/firstLoaderStore";
import { useAgglomerationsDataContext } from "@/store/AgglomerationsProvider";

export default function LoaderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const { userLoading } = useUserDataContext();
  const { agglomerationsLoading } = useAgglomerationsDataContext();
  const { priceRangesLoading } = usePriceRangesDataContext();

  const showFirstLoader = useFirstLoader((s) => s.showFirstLoader);

  const isLoading = userLoading || priceRangesLoading || agglomerationsLoading;

  if (showFirstLoader) {
    return <FirstLoader isLoading={isLoading} />;
  }

  if (isLoading && !showFirstLoader) return <ContainerLoader />;

  return children;
}
